import { getUsersList } from "@/services/people.service";
import { createSlice } from "@reduxjs/toolkit";
import {
  addLocation,
  getActivityList,
  getAvailableLocationList,
  getComplianceStatusLevelList,
  getComplianceStatusList,
  getLocationDetail,
  getLocationEquipments,
  getLocationFilters,
  getLocationPeople,
  getLocations,
  getOrgLocationType,
} from "../services/location.service";

const initialState = {
  locationList: null,
  filteredLocationList: null,
  filteredEquipmentLocationList: [],
  unFilteredEquipmentLocationList: [],
  filteredAvailableLocationList: [],
  unFilteredAvailableLocationList: [],
  locationDetail: null,
  usersList: null,
  locationPeople: null,
  locationEquipmens: [],
  activityList: null,
  complianceStatusList: null,
  complianceStatusLevelList: null,
  getLocationFiltersList: null,
  selectedLocationItem: [],
  getOrgnizationLocationType: [],
};

const location = createSlice({
  name: "location",
  initialState,
  reducers: {
    resetFilteredEquipmentLocationList: (state) => {
      state.filteredEquipmentLocationList = [];
    },
    resetFilteredAvailableLocationList: (state) => {
      state.filteredAvailableLocationList = [];
    },
    addLocationToList: (state, action) => {
      state.locationList = [...state.locationList, action.payload];
    },
    getSelectedLocationItem: (state, action) => {
      state.selectedLocationItem = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addLocation.fulfilled, (state, action) => {
        return {
          ...state,
          initialState: { data: action.payload },
        };
      })
      .addCase(getLocations.fulfilled, (state, action) => {
        const { data = [] } = action?.payload || {};
        const { offset = 0, isFilter } = action.meta.arg || {};

        const activeLocations = data?.filter((loc) => loc.status === "active");
        state.locationList = data;
        state.filteredLocationList = activeLocations || [];

        if (isFilter) {
          state.filteredEquipmentLocationList =
            offset === 0
              ? data
              : state.filteredEquipmentLocationList.concat(data);
        } else {
          state.unFilteredEquipmentLocationList =
            offset === 0
              ? data
              : state.unFilteredEquipmentLocationList.concat(data);
        }
      })
      .addCase(getAvailableLocationList.fulfilled, (state, action) => {
        const { data = [] } = action.payload || {};
        const { offset = 0, isFilter } = action.meta.arg || {};
        if (isFilter) {
          state.filteredAvailableLocationList =
            offset === 0
              ? data
              : state.filteredAvailableLocationList.concat(data);
        } else {
          state.unFilteredAvailableLocationList =
            offset === 0
              ? data
              : state.unFilteredAvailableLocationList.concat(data);
        }
      })
      .addCase(getLocationDetail.fulfilled, (state, action) => {
        state.locationDetail = action.payload?.data;
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.usersList = action.payload?.data?.data;
      })
      .addCase(getLocationPeople.fulfilled, (state, action) => {
        state.locationPeople = action.payload?.data;
      })
      .addCase(getLocationFilters.fulfilled, (state, action) => {
        state.getLocationFiltersList = action.payload?.data;
      })
      .addCase(getLocationEquipments.fulfilled, (state, action) => {
        state.locationEquipmens = action.payload?.data;
      })
      .addCase(getActivityList.fulfilled, (state, action) => {
        state.activityList = action.payload?.data;
      })
      .addCase(getComplianceStatusList.fulfilled, (state, action) => {
        state.complianceStatusList = action.payload?.data;
      })
      .addCase(getComplianceStatusLevelList.fulfilled, (state, action) => {
        state.complianceStatusLevelList = action.payload?.data;
      })
      .addCase(getOrgLocationType.fulfilled, (state, action) => {
        state.getOrgnizationLocationType = action.payload?.data;
      });
  },
});

export const {
  resetFilteredEquipmentLocationList,
  resetFilteredAvailableLocationList,
  getSelectedLocationItem,
} = location.actions;
export default location.reducer;
